import React from 'react';

interface FriendUnitProps {
  friend: {
    tgID: number;
    tgLogin: string | null;
  };
}

const FriendUnit: React.FC<FriendUnitProps> = ({ friend }) => {
  return (
    <div className="flex items-center justify-between p-2 border-b">
      {friend.tgLogin ? (
        // If tgLogin exists, show a clickable link
        <a
          href={`https://t.me/${friend.tgLogin}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-grey-800 hover:underline"
        >
          @{friend.tgLogin}
        </a>
      ) : (
        // If tgLogin does not exist, show the TG user ID
        <span className="text-lg text-grey-800">ID {friend.tgID} TG User</span>
      )}
    </div>
  );
};

export default FriendUnit;